import { create } from "zustand";
import { persist } from "zustand/middleware";

import { ContextsStore } from "./types";

const useContextsStore = create<ContextsStore>()(
  persist(
    (set) => ({
      allItemsQty: 0,
      setAllItemsQty: (allItemsQty) => set({ allItemsQty }),
    }),
    {
      name: "contexts-list-store",
    }
  )
);

export default useContextsStore;
